// extracted by mini-css-extract-plugin
export default {"input-group":"ae8f9f","input-group__label":"cc1b0d","input-group__content":"b1a630","input-group__content--break":"ca5fd4"};